import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import { Col, Form, Input, Row, Space, Spin, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../styles/Main.scss";

const KeyPersonCompany = ({ state, setState, companyId, data }) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const colors = ["#0000"];
  const [apiLoading, setapiloading] = useState(false);

  // Function to handle input changes for key person fields
  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.keypersons;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, keypersons: newPersonArr });
  };

  // Function to remove a key person from the list
  const removePerson = async (lastIndex) => {
    let filterPersonArr = state.keypersons.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, keypersons: filterPersonArr });
    setWeightSizeFieldValue(filterPersonArr);
  };

  // Function to set the values of the form fields based on the keypersons data
  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["person_name" + objectKey] = objectValue.person_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["designation" + objectKey] = objectValue.designation;
      fieldObject["department" + objectKey] = objectValue.department;
      fieldObject["contact_number" + objectKey] = String(
        objectValue.contact_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  // Function to add a new key person to the list
  const addPerson = () => {
    let newPersonArr = [
      ...state.keypersons,
      {
        person_name: null,
        email: null,
        designation: null,
        department: null,
        contact_number: null,
      },
    ];
    setState({ ...state, keypersons: newPersonArr });
    setWeightSizeFieldValue(newPersonArr);
  };

  // Function to handle phone number input changes for key persons
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.keypersons;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, keypersons: newPersonArr });
  };

  // useEffect hook to update form fields when the component mounts or when state, companyId, or t changes
  useEffect(() => {
    if (companyId) {
      const modifiedInquiry = state.keypersons.map((inquiryDetail) => {
        const { id, company, company_name, ...rest } = inquiryDetail;
        return rest;
      });

      setWeightSizeFieldValue(modifiedInquiry);
    }
  }, [state, companyId, t]);

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form onFinish={""} autoComplete="off" ref={formRef}>
          {state.keypersons &&
            state.keypersons.map((x, index) => {
              return (
                <>
                  <Row key={index} className="customcol" gutter={[15]}>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      
                    >
                      <Form.Item
                        name={`person_name` + index}
                        label={t("pl_personName")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("pl_gst")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Enter valid name",
                          },
                          {
                            min: 2,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 15,
                            message: <Trans>{t("maxlength_personName")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          
                          placeholder={t("place_personName")}
                          onChange={(value) =>
                            handleCloneInputChange("person_name", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      
                    >
                      <Form.Item
                        name={`designation` + index}
                        label={t("lbb_designation")}
                        rules={[
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Enter valid designation",
                          },
                        ]}
                      >
                        <Input
                          
                          placeholder={t("place_designation")}
                          onChange={(value) =>
                            handleCloneInputChange("designation", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      
                    >
                      <Form.Item
                        name={`department` + index}
                        label={t("pl_department")}
                        rules={[
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          
                          placeholder={t("place_department")}
                          onChange={(value) =>
                            handleCloneInputChange("department", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={5}
                      xl={5}
                      
                    >
                      <Form.Item
                        name={`email` + index}
                        label={t("lbb_email")}
                        rules={[
                          {
                            type: "email",
                            message: <Trans>{t("val_email")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          
                          placeholder={t("place_email")}
                          onChange={(value) =>
                            handleCloneInputChange("email", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={5}
                      xl={5}
                      
                    >
                      <Form.Item
                        name={`contact_number` + index}
                        label={t("pl_ContactNo")}
                        pattern={"/^d{12}$/"}
                        rules={[
                          {
                            message: <Trans>{t("val_phone")}</Trans>,
                          },
                          {
                            pattern: /^\d{12}$/,
                            message: <Trans>{t("val_phone")}</Trans>,
                          },
                        ]}
                      >
                        <PhoneInput
                          className="PhoneSection"
                          country={"in"}
                          onChange={(phone) =>
                            handleClonePhoneInputChange(
                              "contact_number",
                              phone,
                              index
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={2}
                      xl={2}
                      className="TextFeild addrowkeyperson"
                    >
                      <div className="addwrp" style={{ margin: 0 }}>
                        <Space>
                          {index !== 0 ? (
                            <Tooltip
                              color={colors}
                              title={
                                <span style={{ color: "#000000" }}>
                                  Remove Person
                                </span>
                              }
                            >
                              <MinusSquareFilled
                                className="add"
                                onClick={() => removePerson(index)}
                              />{" "}
                            </Tooltip>
                          ) : (
                            ""
                          )}
                          <Tooltip
                            color={colors}
                            title={
                              <span style={{ color: "#000000" }}>
                                Add Person
                              </span>
                            }
                          >
                            <PlusSquareFilled
                              className="add"
                              onClick={(e) => addPerson(e)}
                            />
                          </Tooltip>
                        </Space>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            })}
        </Form>
      </Spin>
    </>
  );
};
KeyPersonCompany.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  companyId: PropTypes.number,
  data: PropTypes.func,
};
export default KeyPersonCompany;
